<div class="request__step mt-4" style="margin-bottom: 0px;">
  <h3 class="txt txt--section">{{numberSection}}. Carga de documentos</h3>
    <div>
      <b style="color: #e65400">
        Favor adjuntar todos los documentos requeridos, ya que son obligatorios. Los documentos deben ser verídicos para su revisión y aprobación.
      </b>
    </div>
    <div *ngIf="requestType == 'RENEW' && isMineRequest">
      <br>
      <b>
        Para renovaciones se debe realizar Curso: Inducción Conducción Mina, el cual se debe solicitar hora a nibaldo.ne.zepeda@bhp.com. Una vez lo obtenga, debe adjuntar el documento en la parte de renovación en DLMS. El curso dura 4 horas.
      </b>
    </div>
  <div class="table table--documents u-mb10">
    <div class="thead thead--border">
      <div class="tr">
        <div class="th"><b>Nombre documento</b></div>
        <div class="th"><b>Documento</b></div>
        <div class="th"><b>Fecha de vigencia</b></div>
        <div class="th"></div>
      </div>
    </div>
    <div class="tbody">
      <ng-container *ngFor="let item of requiredDocuments; let index = index">
        <div class="tr tr--load" [ngClass]="{
          'tr--required borderTopOrange' : item.isAboutToExpire && index == 0,
          'tr--ready borderTopGreen' : !item.isAboutToExpire && index > 0 && requiredDocuments[index - 1].isAboutToExpire
        }">
          <ng-container *ngFor="let formGroup of [getformGroupByItemId(item.id)]">
            <div class="td td--name td--pt removeBorderBottom"
            [ngClass]="{
              'custom-text-before' : !item.isAboutToExpire && index > 0 && requiredDocuments[index - 1].isAboutToExpire
            }"
            >
              <p>{{item.name}} <app-tooltip [text]="item.description ? getTextOfEntity(item.description) : ''">
                </app-tooltip>
              </p>
              <h6 class="txt txt--paragraph">{{getTextOfEntity(item.hint)}}</h6>
            </div>
            <ng-container *ngIf="this.canReuseOldDocuments && !(formGroupExist(item.id) && formGroup.controls.isActive.value)">
              <div class="td td--doc removeBorderBottom">
                <app-download-document
                  [driverMdmId]="this.driverMdmId"
                  [requirementId]="this.requirementId"
                  [assetId]="this.assetId"
                  [documentId]="item.id"
                  [documentName]="item.description"
                >
                </app-download-document>
              </div>
              <div class="td td--doc removeBorderBottom" *ngFor="let oldDoc of [getPrevDocsById(item.id)]">
                <p *ngIf="oldDoc.dateEmit">Emisión el {{oldDoc.dateEmit | date: 'dd/MM/yyyy'}}</p>
                <p *ngIf="!oldDoc.dateEmit && oldDoc.dateFrom && oldDoc.dateUntil">Del {{oldDoc.dateFrom | date: 'dd/MM/yyyy'}}
                  al {{oldDoc.dateUntil | date: 'dd/MM/yyyy'}}
                </p>
                <p *ngIf="!oldDoc.dateEmit && oldDoc.dateFrom && !oldDoc.dateUntil">Del {{oldDoc.dateFrom | date: 'dd/MM/yyyy'}}
                  a Indefinido
                </p>
              </div>

              <div class="td removeBorderBottom">
                <a
                  class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0 js-load"
                  (click)="activateFormById(item.id)"
                >
                  <img src="assets/img/lapiz.png" alt=""> Renovar documento</a>
              </div>
            </ng-container>
            <ng-container *ngIf="!this.canReuseOldDocuments || (formGroupExist(item.id) && formGroup.controls.isActive.value) ">
              <div class="td td--load td--calendar removeBorderBottom" >
                <div class="form form--required">
                  <app-attach-document
                    [controlForm]="asFormControl(formGroup.controls.file)"
                    [requiredDocumentId]="item.id"
                    [requirementId]="requirementId"
                    [assetId]="assetId"
                    [driverMdmid]="driverMdmId"
                  >
                  </app-attach-document>
                  <app-error-message [text]="documentFileErrorByItemId(item.id)"></app-error-message>
                </div>
              </div>
              <ng-template [ngIf]="item.emit">
                <div class="td td--load td--calendar removeBorderBottom calendar-from">
                  <div class="form form--required">
                    <label for="" class="label">
                      <div class="astObligatoryContainer">Emisión</div>
                    </label>
                    <app-calendar [controlForm]="asFormControl(formGroup.controls.dateEmit)">
                    </app-calendar>
                    <app-error-message [text]="documentDateEmitErrorByItemId(item.id)"></app-error-message>
                    <h6 class="form__info global-unmount">
                      *Formato PDF. Max. 10 MB
                    </h6>
                  </div>
                </div>
                <div class="td td--load td--calendar removeBorderBottom">
                </div>

              </ng-template>
              <ng-template [ngIf]="!item.emit && item.from && item.until">
                <div class="td td--load td--calendar removeBorderBottom calendar-from">
                  <div class="form form--required">
                    <label for="" class="label">
                      <div class="astObligatoryContainer">
                        Desde
                      </div>
                    </label>
                    <app-calendar [controlForm]="asFormControl(formGroup.controls.dateFrom)">
                    </app-calendar>
                    <app-error-message [text]="documentDateFromErrorByItemId(item.id)"></app-error-message>
                    <h6 class="form__info global-unmount">
                      *Formato PDF. Max. 10 MB
                    </h6>
                  </div>
                </div>
                <div class="td td--load td--calendar removeBorderBottom calendar-until">
                  <div class="form form--required">
                    <label for="" class="label">
                      <div class="astObligatoryContainer">
                        Hasta
                      </div>
                    </label>
                    <app-calendar [canBeUndefined]="true" [controlForm]="asFormControl(formGroup.controls.dateUntil)">
                    </app-calendar>
                    <app-error-message [text]="documentDateRangeErrorByItemId(item.id)"></app-error-message>
                    <h6 class="form__info global-unmount">
                      *Formato PDF. Max. 10 MB
                    </h6>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="gettingDocumentsRequired" style="width: 100%; height: 60px; min-height: 60px; margin: 10px;">
    <app-loader></app-loader>
  </div>

  <button
    type="button"
    class="btn btn--primary modal__trigger"
    [ngClass]="requiredDocuments.length === 0 ? 'global-unmount' : ''"
    (click)="showModalDocumentsRequired()"
  >
    Revisar documentos
  </button>

</div>
